import CategoryPageLayout from "@/components/CategoryPageLayout";
import infissi1 from "@/assets/infissi-1.jpg";
import infissi2 from "@/assets/infissi-2.jpg";
import infissi3 from "@/assets/infissi-3.jpg";
import infissi4 from "@/assets/infissi-4.jpg";
import infissi5 from "@/assets/infissi-5.jpg";
import infissi6 from "@/assets/infissi-6.jpg";

const subcategories = [
  { image: infissi1, title: "Finestre in alluminio", description: "Taglio termico, isolamento e design moderno", slug: "finestre-alluminio" },
  { image: infissi2, title: "Porte scorrevoli", description: "Vetrate panoramiche per interni luminosi", slug: "porte-scorrevoli" },
  { image: infissi3, title: "Persiane e avvolgibili", description: "Oscuramento e sicurezza su misura", slug: "persiane-avvolgibili" },
  { image: infissi4, title: "Porte blindate", description: "Protezione certificata, finiture eleganti", slug: "porte-blindate" },
  { image: infissi5, title: "Zanzariere", description: "Protezione discreta e funzionale", slug: "zanzariere" },
  { image: infissi6, title: "Finestre in legno", description: "Calore e tradizione con doppi vetri", slug: "finestre-legno" },
];

const InfissiPage = () => (
  <CategoryPageLayout
    heading="Infissi & Serramenti"
    subtitle="Soluzioni su misura per comfort, isolamento e finiture curate. Finestre, porte, persiane e zanzariere."
    basePath="/infissi"
    subcategories={subcategories}
  />
);

export default InfissiPage;
